import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { PreguntaComponent } from './pregunta/pregunta.component';
import Swal from 'sweetalert2';
import { fuseAnimations } from '@fuse/animations';

import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import * as backInter from 'app/auth/auth-data.model';

///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
@Component({
  selector: 'preguntasAdicionales',
  templateUrl: './preguntas.component.html',
  styleUrls: ['./preguntas.component.scss'],
  animations   : fuseAnimations
})
export class PreguntasComponent implements OnInit {

  @Input('productoCertificar') productoCertificar: backInter.prodCert;
  @Input('idiomas') idiomas: backInter.getIdiomas;
  @Input('preguntasAdicionales') preguntasAdicionales: backInter.getAdicionales;
  @Input('cargando') cargando: boolean;
  @Input('pasoCompleto') pasoCompleto: boolean;

  @Output() actualizarAdicionales: EventEmitter<boolean> = new EventEmitter();
  @Output() statusSinAdicionales: EventEmitter<boolean> = new EventEmitter();

  ////VARIABLES
  preguntas: any[] = []
  iterador = 0;

  //boolean adicionales
  sinAdic = false;
  //id idioma "sin adicionales"
  idSinAdic: string;
  instituto:any;
  // pasoCompleto = false;

  constructor(
    private wizardService: WizardService,
    private adicionalesService: AdicionalesService,
    private translateSrv: TranslateService,
    private _snackBar: MatSnackBar,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
    lang_modales.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    let esperaDatos = setInterval( () => {
      if(this.preguntasAdicionales){
        this.colocaOpcionSinAdicionales();
        if(!this.idSinAdic)
          this.colocaPreguntasExistentes();
        clearInterval(esperaDatos);
      }
    }, 0);
    this.obtieneInstituto();
  }

  obtieneInstituto(){
    let institutoAct = this.wizardService.getInstituto();
    // console.log(institutoAct);
    switch(institutoAct){
      case '1': case 'MX': this.instituto = 'MX'; break;
case '2': case 'CAyC': this.instituto = 'CAyC'; break;
case '3': case 'HK': this.instituto = 'HK'; break;
case '4': case 'SGP': this.instituto = 'SGP'; break;
case '5': case 'TK': this.instituto = 'TK'; break;
case '6': case 'FL': this.instituto = 'FL'; break;
case '11': case 'BR': this.instituto = 'BR'; break;
    }
    console.log("Instituo "+this.instituto);
  }

  colocaOpcionSinAdicionales(){
    if(this.preguntasAdicionales.adicionalesMostrar.length == 1){
      if(this.preguntasAdicionales.adicionalesMostrar[0].orden == -1){
        this.idSinAdic = this.preguntasAdicionales.adicionalesMostrar[0]._id;
        this.sinAdic = true;
      }
    }
  }

  colocaPreguntasExistentes(){
      if(this.preguntasAdicionales.adicionalesMostrar.length > 0){
        this.preguntasAdicionales.adicionalesMostrar.forEach( (elemento) => {
          this.agregaPregunta(elemento);
        });
      };
  }

  agregaPregunta(datosPregunta?:backInter.getAdicional){
    this.preguntas.push({iterador:this.iterador, datosPregunta:datosPregunta});
    this.iterador++;
  }

  borrarPregunta(id: number){
    let index = 0;
    var BreakException = {};
    try {
        this.preguntas.forEach(function(elemento) {
          if(elemento.iterador === id) throw BreakException;
          index++;
        });
    } catch (e) {
        if (e !== BreakException) throw e;
    }
    this.preguntas.splice(index,1);
    // this.openSnackBar("Se eliminó la pregunta","OK");
  }

  sinAdicionales(e){
    if(!this.pasoCompleto){
      this.sinAdic = !this.sinAdic;
      if(this.sinAdic){
        if(this.idSinAdic == null){
          this.guardaPreguntaSinAdicionales();
        }
      }
      else{
        this.eliminaPreguntaSinAdicionales();
      }
    }
    else{
      e.preventDefault();
      this.translateSrv.get('MODALES.MENSAJES.WIZARD.CERTIFICAR.ADICIONALES.RESTRICCION').subscribe((res: string) => {
        this.mensajeSwal({mensaje: res ,tipo: 'warning'});
      });
    }
  }

  guardaPreguntaSinAdicionales(){
    let adicional = {} as backInter.nuevoAdicional;
    adicional.fechaCertificar = this.productoCertificar.fechaCertificar;
    adicional.tipoPreguntaAdicionales = 3;
    adicional.textoPregunta = "sin adicionales";
    adicional.idiomaAdicionales = "0";
    adicional.orden = -1;

    // console.log(adicional);
    this.adicionalesService.guardaAdicional(adicional).subscribe( (data: backInter.respuestaNuevoAdicional) => {
      if(data.message == "240"){
        this.idSinAdic = data.idAdicionalExterna;
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.NOADICIONALES').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
        this.statusSinAdicionales.emit(true);
      }
      else{
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.ERROR').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
      }
    });
  }
  
  eliminaPreguntaSinAdicionales(){
    let adicional = {} as backInter.modificaAdicional;
    adicional.fechaCertificar = this.productoCertificar.fechaCertificar;
    adicional.arrayId = this.idSinAdic;
    adicional.vivoAdicional = "0";
console.log(adicional);

    this.adicionalesService.borraAdicional(adicional).subscribe( (data:backInter.respuestaModifAdicional) => {
      if(data.message == "Success"){
        this.idSinAdic = null;
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.CANCELNOADIC').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
        this.statusSinAdicionales.emit(false);
      }
      else{
        this.translateSrv.get('CERTIFICAR.ADICIONALES.PREGUNTAS.STATUS.ERROR').subscribe((res: string) => {
          this.openSnackBar(res,'OK');
        });
      }
    });

  }

  mensajeSnack(datos:any){
    this.openSnackBar(datos.mensaje,datos.accion);

    //actualiza arreglo de adicionales
    this.actualizarAdicionales.emit(true);
  }
  mensajeSwal(datos:any){
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    Swal.fire({
      title: datos.mensaje,
      icon: datos.tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });

    //actualiza arreglo de adicionales
    this.actualizarAdicionales.emit(true);
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.preguntas, event.previousIndex, event.currentIndex);
  }

}
